import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  cancelRequestAction,
  getAllChatUserActionByNumber,
  getAllChatUserActionBySearch,
  getAllNotificationsAction,
  removeRequestAction,
} from '../../../redux/actions/chatActions';
import { useHistory } from 'react-router-dom';

const useChatRequestsFunctions = socket => {
  const dispatch = useDispatch();
  const [mySocketData, setMySocketData] = useState({});

  const [chatUserLoading, setChatUserLoading] = useState(false);
  const [chatUsers, setChatUsers] = useState([]);
  const [chatUserSearch, setChatUserSearch] = useState('');

  const [pendingCircularLoader, setPendingCircularLoader] = useState(false);
  const [notAvailableCircularLoader, setNotAvailableCircularLoader] = useState(false);
  const [notAcceptedCircularLoader, setNotAcceptedCircularLoader] = useState(false);

  const [hasMorePendingData, setHasMorePendingData] = useState(true);
  const [isPendingSearching, setIsPendingSearching] = useState(false);
  const [pendingPage, setPendingPage] = useState(2);

  const [hasMoreAvailableData, setHasMoreAvailableData] = useState(true);
  const [isAvailableSearching, setIsAvailableSearching] = useState(false);
  const [availablePage, setAvailablePage] = useState(2);

  const [hasMoreNotAcceptedData, setHasMoreNotAcceptedData] = useState(true);
  const [isNotAcceptedSearching, setIsNotAcceptedSearching] = useState(false);
  const history = useHistory();
  const [notAcceptedPage, setNotAcceptedPage] = useState(2);

  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const [pendingChatUserLoading, setPendingChatUserLoading] = useState(false);
  const [pendingChatUsers, setPendingChatUsers] = useState({
    data: [],
  });
  const [pendingChatSearch, setPendingChatSearch] = useState('');

  const [prevSentRequestLoading, setPrevSentRequestLoading] = useState(false);
  const [prevSentRequests, setPrevSentRequests] = useState([]);
  const [prevSentSearch, setPrevSentSearch] = useState('');

  const userLogin = useSelector(state => state.userLogin);
  const onlineUsers = useSelector(state => state.onlineUsers);

  const cardListRef1 = useRef(null);
  const cardListRef2 = useRef(null);
  const cardListRef3 = useRef(null);

  const getChatUsers = useCallback(async () => {
    setChatUserLoading(true);
    const data = await dispatch(getAllChatUserActionByNumber('notavailable', 1));
    setChatUserLoading(false);
    setChatUsers(data);
  }, [dispatch]);

  const getPendingChatUsers = useCallback(async () => {
    setPendingChatUserLoading(true);
    const data = await dispatch(getAllChatUserActionByNumber('pending', 1));
    setPendingChatUserLoading(false);
    setPendingChatUsers(data);
  }, [dispatch]);

  const getPrevSendRequestData = useCallback(async () => {
    setPrevSentRequestLoading(true);
    const data = await dispatch(getAllChatUserActionByNumber('notaccepted', 1));
    setPrevSentRequestLoading(false);
    setPrevSentRequests(data);
  }, [dispatch]);

  useEffect(() => {
    getChatUsers();
    getPendingChatUsers();
    getPrevSendRequestData();
  }, []);

  useEffect(() => {
    const mySocket =
      onlineUsers.onlineUsers &&
      userLogin &&
      userLogin.userInfo &&
      userLogin.userInfo.data &&
      userLogin.userInfo.data.user &&
      Object.values(onlineUsers.onlineUsers).find(onlineUser => onlineUser['userId'] === userLogin.userInfo.data.user._id);
    // onlineUsers.onlineUsers.filter((onlineUser) => onlineUser['userId'] === userLogin.userInfo.data.user._id)[0];
    setMySocketData(mySocket);
  }, [onlineUsers, userLogin]);

  useEffect(() => {
    if (socket) {
      socket.on('sendRequest', () => {
        getPendingChatUsers();
        getChatUsers();
      });

      socket.on('sendRequestSuccess', () => {
        getChatUsers();
        getPendingChatUsers();
        getPrevSendRequestData();
      });
      socket.on('acceptRequest', () => {
        getPrevSendRequestData();
      });
      socket.on('acceptRequestSuccess', () => {
        getPendingChatUsers();
      });
      socket.on('removeRequest', () => {
        getPendingChatUsers();
      });
      socket.on('cancelRequest', () => {
        getPrevSendRequestData();
        getChatUsers();
      });

      //group request events
      socket.on('acceptGroupRequestSuccess', response => {
        if (response.data.status) {
          setToastMessage('Request Accepted');
          setShowSuccessToast(true);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          setToastMessage('Request not accepted try again !');
          setShowErrorToast(true);
        }
      });

      socket.on('cancelPendingRequestSelfSuccess', response => {
        if (response.data.status) {
          setToastMessage('Request Canceled');
          setShowSuccessToast(true);
        } else {
          setToastMessage('Request not accepted try again !');
          setShowErrorToast(true);
        }
      });

      socket.on('GroupRequestSendResponse', response => {
        if (response) {
          getChatUsers();
          getPendingChatUsers();
        }
      });
    }
  }, [socket, getChatUsers, getPrevSendRequestData, getPendingChatUsers]);

  const handleSendReqest = async userId => {
    // Support both legacy (data.user) and Regure (data.data) user shapes
    const currentUser = userLogin?.userInfo?.data?.user || userLogin?.userInfo?.data?.data;
    if (socket && mySocketData && Object.keys(mySocketData).length > 0 && mySocketData.socketId && currentUser && onlineUsers && onlineUsers.onlineUsers) {
      const toSocketId = Object.values(onlineUsers.onlineUsers).find(onlineUser => onlineUser['userId'] === userId);

      const org = currentUser.org;

      const formData = {
        user: userId,
        myName: currentUser.name,
        org,
        mySocketId: mySocketData.socketId,
      };
      if (toSocketId && toSocketId.socketId) {
        formData.toSocketId = toSocketId.socketId;
      }
      socket.emit('channelSendRequest', formData);
    } else {
      setToastMessage('Request not sent try again !');
      setShowErrorToast(true);
    }
    // const data = await dispatch(sendRequestAction(userId));

    // if (data && data.status === 'success') {
    // 	getChatUsers();
    // 	getPrevSendRequestData();
  };

  const handleAcceptRequest = async userId => {
    const currentUser = userLogin?.userInfo?.data?.user || userLogin?.userInfo?.data?.data;
    if (socket && mySocketData && Object.keys(mySocketData).length > 0 && mySocketData.socketId && onlineUsers && onlineUsers.onlineUsers && currentUser) {
      // const userSocketId = onlineUsers.onlineUsers.filter((onlineUser) => onlineUser['userId'] === userId)[0];
      const toSocketId = Object.values(onlineUsers.onlineUsers).find(onlineUser => onlineUser['userId'] === userId);

      const formData = {
        user: userId,
        myName: currentUser.name,
        mySocketId: mySocketData.socketId,
      };

      if (toSocketId && toSocketId.socketId) {
        formData.toSocketId = toSocketId.socketId;
      }
      socket.emit('channelAcceptRequest', formData);
    } else {
      console.log('socket', socket);
      console.log('mySocketData', mySocketData);
      console.log('onlineUsers', onlineUsers);
      console.log('currentUser', currentUser);

      setToastMessage('Request not accepted try again !');
      setShowErrorToast(true);
    }

    // const data = await dispatch(acceptRequestAction(userId));

    // if (data && data.status === 'success') {
    // 	getPendingChatUsers();
    // }
  };

  const handleAcceptGroupRequest = useCallback(
    async groupId => {
      if (
        socket &&
        mySocketData &&
        Object.keys(mySocketData).length > 0 &&
        mySocketData.socketId &&
        onlineUsers &&
        onlineUsers.onlineUsers &&
        userLogin &&
        userLogin.userInfo &&
        userLogin.userInfo.data &&
        userLogin.userInfo.data.user
      ) {
        const formData = {
          groupId: groupId,
          mySocketId: mySocketData.socketId,
        };

        socket.emit('acceptGroupRequest', formData);
      }
      const updatedData = pendingChatUsers.data.filter(dataObj => dataObj._id !== groupId);
      setPendingChatUsers({ ...pendingChatUsers, data: updatedData });
    },
    [mySocketData, onlineUsers, pendingChatUsers, socket, userLogin],
  );

  const handleCancelGroupRequest = useCallback(
    async userId => {
      if (
        socket &&
        mySocketData &&
        Object.keys(mySocketData).length > 0 &&
        mySocketData.socketId &&
        onlineUsers &&
        onlineUsers.onlineUsers &&
        userLogin &&
        userLogin.userInfo &&
        userLogin.userInfo.data &&
        userLogin.userInfo.data.user
      ) {
        const formData = {
          groupId: userId,
          mySocketId: mySocketData.socketId,
        };
        socket.emit('cancelPendingRequestSelf', formData);
      }
      const updatedData = pendingChatUsers.data.filter(dataObj => dataObj._id !== userId);
      setPendingChatUsers({ ...pendingChatUsers, data: updatedData });
    },
    [mySocketData, onlineUsers, pendingChatUsers, socket, userLogin],
  );

  const handleRemoveRequest = async userId => {
    const data = await dispatch(removeRequestAction(userId));

    if (onlineUsers && onlineUsers.onlineUsers) {
      const toSocketId = Object.values(onlineUsers.onlineUsers).find(onlineUser => onlineUser['userId'] === userId);

      if (toSocketId && toSocketId.socketId) {
        socket.emit('channelRemoveRequest', {
          toSocketId: toSocketId.socketId,
        });
      }
    }

    if (data && data.status === 'success') {
      getChatUsers();
      getPrevSendRequestData();
    }
  };

  const handleCancelRequest = async userId => {
    const data = await dispatch(cancelRequestAction(userId));
    dispatch(getAllNotificationsAction('get', '', 1));

    if (onlineUsers && onlineUsers.onlineUsers) {
      const userSocketId = onlineUsers.onlineUsers.filter(onlineUser => onlineUser['userId'] === userId)[0];
      if (userSocketId && userSocketId.socketId) {
        socket.emit('channelCancelRequest', {
          toSocketId: userSocketId.socketId,
        });
      }
    }

    if (data && data.status === 'success') {
      getPendingChatUsers();
      getChatUsers();
    }
  };

  const pendingSearch = useCallback(
    async query => {
      setIsPendingSearching(true);
      if (query.length > 0) {
        setPendingCircularLoader(true);
        const data = await dispatch(getAllChatUserActionBySearch('pending', query));
        setTimeout(() => {
          setPendingCircularLoader(false);
        }, 2000);
        setPendingChatUsers(data);
      } else {
        getPendingChatUsers();
        setIsPendingSearching(false);
      }
    },
    [dispatch, getPendingChatUsers],
  );

  const notAvailableusersSearch = useCallback(
    async query => {
      setIsAvailableSearching(true);
      if (query.length > 0) {
        setNotAvailableCircularLoader(true);
        const data = await dispatch(getAllChatUserActionBySearch('notavailable', query));
        setTimeout(() => {
          setNotAvailableCircularLoader(false);
        }, 2000);
        setChatUsers(data);
      } else {
        getChatUsers();
        setIsAvailableSearching(false);
      }
    },
    [dispatch, getChatUsers],
  );

  const notAcceptedUsersSearch = useCallback(
    async query => {
      setIsNotAcceptedSearching(true);
      if (query.length > 0) {
        setNotAcceptedCircularLoader(true);
        const data = await dispatch(getAllChatUserActionBySearch('notaccepted', query));
        setTimeout(() => {
          setNotAcceptedCircularLoader(false);
        }, 2000);
        setPrevSentRequests(data);
      } else {
        getPrevSendRequestData();
        setIsNotAcceptedSearching(false);
      }
    },
    [dispatch, getPrevSendRequestData],
  );

  const fetchPendingData = useCallback(async () => {
    if (!pendingCircularLoader && hasMorePendingData && !isPendingSearching) {
      setPendingCircularLoader(true);
      const data = await dispatch(getAllChatUserActionByNumber('pending', pendingPage));
      if (data.data.length > 0) {
        setPendingChatUsers(prevResults => {
          const updatedData = {
            ...prevResults,
            data: [...prevResults.data, ...data.data],
          };
          return updatedData;
        });
        setPendingPage(prevPage => prevPage + 1);
        setHasMorePendingData(true);
      } else {
        setHasMoreAvailableData(false);
        setHasMorePendingData(false);
      }

      setPendingCircularLoader(false);
    }
  }, [pendingCircularLoader, dispatch, hasMorePendingData, isPendingSearching, pendingPage]);

  const fetchNotAvailableData = useCallback(async () => {
    if (!notAvailableCircularLoader && hasMoreAvailableData && !isAvailableSearching) {
      setNotAvailableCircularLoader(true);
      const data = await dispatch(getAllChatUserActionByNumber('notavailable', availablePage));

      if (data.data.length > 0) {
        setChatUsers(prevResults => {
          const updatedData = {
            ...prevResults,
            data: [...prevResults.data, ...data.data],
          };
          return updatedData;
        });
        setAvailablePage(prevPage => prevPage + 1);
        setHasMoreAvailableData(true);
      } else {
        setHasMoreAvailableData(false);
      }

      setNotAvailableCircularLoader(false);
    }
  }, [notAvailableCircularLoader, hasMoreAvailableData, isAvailableSearching, dispatch, availablePage]);

  const fetchNotAcceptedData = useCallback(async () => {
    if (!notAcceptedCircularLoader && hasMoreNotAcceptedData && !isNotAcceptedSearching) {
      setNotAcceptedCircularLoader(true);
      const data = await dispatch(getAllChatUserActionByNumber('notaccepted', notAcceptedPage));
      if (data.data.length > 0) {
        setPrevSentRequests(prevResults => {
          const updatedData = {
            ...prevResults,
            data: [...prevResults.data, ...data.data],
          };
          return updatedData;
        });
        setNotAcceptedPage(prevPage => prevPage + 1);
        setHasMoreNotAcceptedData(true);
      } else {
        setHasMoreNotAcceptedData(false);
      }

      setNotAcceptedCircularLoader(false);
    }
  }, [notAcceptedCircularLoader, hasMoreNotAcceptedData, isNotAcceptedSearching, dispatch, pendingPage]);

  const handlePendingScroll = useCallback(() => {
    if (cardListRef1.current) {
      const { scrollTop, clientHeight, scrollHeight } = cardListRef1.current;
      if (scrollTop + clientHeight >= scrollHeight - 1 && hasMorePendingData) {
        fetchPendingData();
      }
    }
  }, [fetchPendingData, hasMorePendingData]);

  const handleNotAvailableUsersScroll = useCallback(() => {
    if (cardListRef2.current) {
      const { scrollTop, clientHeight, scrollHeight } = cardListRef2.current;
      if (scrollTop + clientHeight >= scrollHeight - 2 && hasMoreAvailableData) {
        fetchNotAvailableData();
      }
    }
  }, [fetchNotAvailableData, hasMoreAvailableData]);

  const handleNotAcceptedUsersScroll = useCallback(() => {
    if (cardListRef3.current) {
      const { scrollTop, clientHeight, scrollHeight } = cardListRef3.current;
      if (scrollTop + clientHeight >= scrollHeight - 2 && hasMoreNotAcceptedData) {
        fetchNotAcceptedData();
      }
    }
  }, [fetchNotAcceptedData, hasMoreNotAcceptedData]);

  useEffect(() => {
    if (
      userLogin &&
      userLogin.userInfo &&
      userLogin.userInfo.data &&
      userLogin.userInfo.data.user &&
      userLogin.userInfo.data.user.modules &&
      !userLogin.userInfo.data.user.modules.chat
    ) {
      history.push('/');
    }
  }, [history, userLogin]);

  useEffect(() => {
    if (cardListRef1.current) {
      cardListRef1.current.addEventListener('scroll', handlePendingScroll);
    }
    if (cardListRef2.current) {
      cardListRef2.current.addEventListener('scroll', handleNotAvailableUsersScroll);
    }
    if (cardListRef3.current) {
      cardListRef3.current.addEventListener('scroll', handleNotAcceptedUsersScroll);
    }

    return () => {
      if (cardListRef1.current) {
        cardListRef1.current.removeEventListener('scroll', handlePendingScroll);
      }
      if (cardListRef2.current) {
        cardListRef2.current.removeEventListener('scroll', handleNotAvailableUsersScroll);
      }
      if (cardListRef3.current) {
        cardListRef3.current.removeEventListener('scroll', handleNotAcceptedUsersScroll);
      }
    };
  }, [hasMorePendingData, hasMoreNotAcceptedData, hasMoreAvailableData, handlePendingScroll, handleNotAvailableUsersScroll, handleNotAcceptedUsersScroll]);

  return {
    chatUserLoading,
    chatUsers,
    chatUserSearch,
    setChatUserSearch,
    pendingCircularLoader,
    notAvailableCircularLoader,
    notAcceptedCircularLoader,
    showErrorToast,
    setShowErrorToast,
    showSuccessToast,
    setShowSuccessToast,
    toastMessage,
    pendingChatUserLoading,
    pendingChatUsers,
    pendingChatSearch,
    setPendingChatSearch,
    prevSentRequestLoading,
    prevSentRequests,
    prevSentSearch,
    setPrevSentSearch,
    cardListRef1,
    cardListRef2,
    cardListRef3,
    handleSendReqest,
    handleAcceptRequest,
    handleAcceptGroupRequest,
    handleCancelGroupRequest,
    handleRemoveRequest,
    handleCancelRequest,
    pendingSearch,
    notAvailableusersSearch,
    notAcceptedUsersSearch,
    userLogin,
  };
};

export default useChatRequestsFunctions;
